<template>
  <!-- 
    @name 流水报告
   -->
  <div class="hang_credit">
    <div class="bg_else" style="text-align: center;" v-if="reportUrl == ''">
      <div class="prompt">提示：用户未上传流水报告，请联系用户上传！</div>
    </div>
    <div id="" v-else>
      <div class="create" style="text-align: center;">
        <el-button
          type="warning"
          style="width: 120px"
          plain
          @click="createESign"
          >查看流水报告</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reportUrl"],
  data() {
    return {

    };
  },
  mounted() {
    console.log("重新生成报告", this.reportUrl);

  },
  methods: {
    createESign() {
      window.open(this.reportUrl);
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.bg_else .prompt {
  margin-top: 50px;
  font-size: 30px;
}

.bg_else .report {
  /* margin-left: 700px; */
  font-size: 30px;
}

.bg_else .create {
  /* margin-left: 760px; */
  font-size: 30px;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/fengkong/operation/flowReport.vue